export default {
    CheckBox: {
        UseStatistic: 'Tính số dư tạm ứng theo Mã thống kê'
    }
}